import {  faFilterList } from '@fortawesome/pro-regular-svg-icons'
import {  Menu, Button } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { FilterCategories } from './FilterCategories'
import { FilterContent } from './FilterContent'

export type CardFiltersProps = {
  withCategories?: boolean
}

export function DropdownFilters({
  withCategories = true,
}: CardFiltersProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  return (
    <Menu position='bottom-start' shadow='md'>
      <Menu.Target>
        <Button variant='default' size='sm' leftSection={<Icon icon={faFilterList} color='dimmed' />}>
          {t('label_filters')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown p='md'>
        <FilterContent />
        {withCategories && <FilterCategories mt='md' />}
      </Menu.Dropdown>
    </Menu>
  )
}
